import { useTranslation } from 'react-i18next';
import { useFilterStore } from '../store/filter-store';
import { Switch } from '@/components/ui/Switch';

/**
 * Availability filter section - Single "Only available" toggle
 */
export function AvailabilityFilter() {
  const { t } = useTranslation();
  const showOnlyAvailable = useFilterStore((s) => s.showOnlyAvailable);
  const setShowOnlyAvailable = useFilterStore((s) => s.setShowOnlyAvailable);

  return (
    <div className="space-y-3 pt-3 pb-2">
      <Switch
        checked={showOnlyAvailable}
        onCheckedChange={setShowOnlyAvailable}
        label={t('filters.onlyAvailable')}
      />
    </div>
  );
}
